import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).on("click", ".toggle", (e) => {
      e.stopPropagation()
      const input = $(this.element).find("input#agent_turbo_mode")
      const form = $(this.element).find("form")
      const isChecked = input.prop("checked")
      input.prop("checked", !isChecked).trigger("change")
      form[0].requestSubmit()
    })

    $(this.element).on("click", ".fa-info-circle", (e) => {
      e.stopPropagation()
    })

    $(this.element).find("input#agent_turbo_mode").bootstrapToggle()
  }
}
